import { EServiceId, EServiceType } from '../../redux/reducers';

/**
 * Использовать только в слое маппинга данных.
 * Если хочешь использовать в слоях ниже, значит что-то пошло не так,
 * поскольку сущности в сторе должны быть уже нормализованными, с полем serviceId
 */
export function getServiceId(serviceTypes: EServiceType[]): EServiceId {
  return serviceTypes.join('+') as EServiceId;
}
